import { createContext } from "react";
import vitat from "./vitat";

export default createContext(vitat);
